export default __webpack_public_path__ + "static/media/image-6.2eaf8c75.webp";